import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { MatchupStatusEnum } from '@/entities/matchup/constants';

const statusText: Record<MatchupStatusEnum, string> = {
	[MatchupStatusEnum.SCHEDULED_MATCHUP_STATUS]: 'Waiting to start',
	[MatchupStatusEnum.SCHEDULED_WAITING_FOR_HOME_TEAM_LINEUP]: 'Waiting to start',
	[MatchupStatusEnum.SCHEDULED_WAITING_FOR_AWAY_TEAM_LINEUP]: 'Waiting to start',
	[MatchupStatusEnum.IN_PROGRESS_MATCHUP_STATUS]: 'In Progress',
	[MatchupStatusEnum.COMPLETED_MATCHUP_STATUS]: 'Completed',
	[MatchupStatusEnum.DELAYED_MATCHUP_STATUS]: 'Delayed',
	[MatchupStatusEnum.UNSCHEDULED_MATCHUP_STATUS]: 'Unscheduled',
	[MatchupStatusEnum.UNDEFINED_MATCHUP_STATUS]: 'Undefined',
	[MatchupStatusEnum.READY_TO_BE_STARTED_STATUS]: 'Waiting to start',
	[MatchupStatusEnum.BYE_MATCHUP_STATUS]: 'Waiting to start'
};

interface Props {
	matchupStatus: MatchupStatusEnum;
}

export const MatchupStatusBadge = ({ matchupStatus }: Props) => {
	return (
		<div className="flex gap-2 items-center">
			<FontAwesomeIcon icon={faCircle} size="sm" className="text-gray-500 size-2" />
			<p className="font-medium text-sm text-gray-700">{statusText[matchupStatus]}</p>
		</div>
	);
};
